import styled from 'styled-components';

import { Box } from '@mui/material';
import { SubRollingOfferUiProps } from 'templates/RollingOffer/shared/types';
import { motion } from 'framer-motion';
import {
  arrowHeightWidth,
  containerPadding,
} from 'templates/RollingOffer/shared/utils';
import { breakpoints } from 'styles/breakpoints';

export interface StyledSubRollingOfferProps extends SubRollingOfferUiProps {
  clickable?: boolean;
}

export const StyledArrowWrapper = styled(Box)<{
  height: number;
  paddingLeft: string;
  paddingRight: string;
}>`
  height: ${({ height }) => height}px;
  padding-left: ${({ paddingLeft }) => paddingLeft};
  padding-right: ${({ paddingRight }) => paddingRight};
  align-items: center;
  display: flex;
`;

export const StyledArrowImage = styled.img<{ rotation: string; size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  transition: transform 0.2s ease-in-out;
  transform: ${({ rotation }) => rotation};
`;

export const StyledSubOfferWrapper = styled(motion.div)<{
  isHorizontalViewEnabled: boolean;
}>`
  width: calc(50% - ${arrowHeightWidth / 2 + containerPadding}px);
  position: absolute;
  display: flex;
  z-index: 1;

  ${({ isHorizontalViewEnabled }) =>
    isHorizontalViewEnabled &&
    `
      @media (min-width: ${breakpoints.desktopS}) {
        width: 220px;
        height: auto;
        position: static;
        overflow: visible;
        padding: 0;
      }
    `}
`;
